var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:({ background: _vm.$vuetify.theme.themes[_vm.theme].background })},[_c('Loader'),_c('SnackbarAlert'),_c('v-container',{attrs:{"fluid":""}},[(_vm.$DEBUG)?_c('DebugButton'):_vm._e(),_c('transition',{attrs:{"name":"fade"}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }